import { render, staticRenderFns } from "./reportdepartmentsumdetail.vue?vue&type=template&id=6fc8d35a&"
import script from "./reportdepartmentsumdetail.vue?vue&type=script&lang=js&"
export * from "./reportdepartmentsumdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports